angular
  .module('hybrid-ng-personal-reminders')
  .component('reminderAddButton', {
    templateUrl:
      'hybrid-ng-personal-reminders/src/components/personal_reminder_add_button/personal_reminder_add_button.html',
    controller: 'addReminderButtonController'
  })
  .controller('addReminderButtonController', function addReminderButtonController($state) {
    this.goToCreateReminder = () => {
      $state.go('my.newreminder');
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/hybrid-ng-personal-reminders/src/components/personal_reminder_add_button/personal_reminder_add_button_component.es.js